import React from "react";

import Page from "~/models/page";

type Props = {
  page: Page;
  sd: any;
  noindex?: boolean;
  children?: any;
};

function SEO({ page, sd, noindex, children }: Props) {
  const blockIndex = page.noindex || noindex;

  return (
    <React.Fragment>
      <title>{page.metaTitle}</title>
      <meta
        name="description"
        content={page.description || page.excerpt?.slice(0, 140)}
      />
      {blockIndex && <meta name="robots" content="noindex, follow" />}
      <link
        rel="canonical"
        href={`${process.env.GATSBY_SITE_URL}${page.url.pathname}`}
      />
      <meta name="format-detection" content="telephone=no" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=5"></meta>
      <meta property="og:title" content={page.metaTitle} />
      <meta property="og:type" content="website" />
      <meta
        property="og:image"
        content={
          page.imageUrls
            ? page.imageUrls.ogp.publicURL
            : `${process.env.GATSBY_SITE_URL}/images/ogp.png`
        }
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:url"
        content={`${process.env.GATSBY_SITE_URL}${page.url.pathname}`}
      />
      <meta
        property="og:description"
        content={page.description || page.excerpt?.slice(0, 140)}
      />
      {!blockIndex && (
        <meta name="robots" content="max-image-preview:large" />
      )}
      <meta
        property="og:site_name"
        content="unprinted | 「より良い未来」をつくるデザイナーのためのWork & Lifeマガジン"
      />
      <meta name="twitter:title" content={page.metaTitle} />
      <meta
        name="twitter:description"
        content={page.description || page.excerpt?.slice(0, 140)}
      />
      <meta
        name="twitter:image"
        content={
          page.imageUrls
            ? page.imageUrls.ogp.publicURL
            : `${process.env.GATSBY_SITE_URL}/images/ogp.png`
        }
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@unprinteddesign" />
      {sd.length && (
        <script type="application/ld+json">{JSON.stringify(sd)}</script>
      )}
      <link rel="icon" href="/images/favicon-16x16.png" type="image/png" />
      <link rel="icon" href="/images/favicon-32x32.png" type="image/png" />
      <link
        rel="shortcut icon"
        href="/images/favicon-64x64.png"
        type="image/png"
      />
      {/* <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5860972762185906"
        crossOrigin="anonymous"></script> */}
      {process.env.GATSBY_VWO_ACCOUNT_ID && (
        <React.Fragment>
          <link
            rel="preconnect"
            href="https://dev.visualwebsiteoptimizer.com"
          />
          <script
            type="text/javascript"
            key="gatsby-plugin-vwo-smartcode"
            id="vwoCode"
            dangerouslySetInnerHTML={{
              __html: `
            window._vwo_code || (function() {
            var account_id=${process.env.GATSBY_VWO_ACCOUNT_ID},
            version=2.0,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();
            `,
            }}
          />
        </React.Fragment>
      )}
      {children}
    </React.Fragment>
  );
}

export default SEO;
